import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';

import withModal from '../../../../../components/global/modal/withModal';
import DismissButton from '../../../../../components/global/DismissButton';
import getSystemStickers from '../../../graphql/queries/getSystemStickers';
import { createLoadMoreMethod } from '../../../../../util/apollo';
import NativeActivityIndicator from '../../../../../components/global/NativeActivityIndicator';
import useVirtualPageView from '../../../../../apps/pro/services/analytics/useVirtualPageView';
import TrashIcon from '../../../../../components/icons/TrashIcon';

const propTypes = {
  systemStickers: PropTypes.shape({
    total: PropTypes.number.isRequired,
    records: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        asset_image: PropTypes.shape({
          id: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    ).isRequired,
  }),
  loadMore: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
};

const CardElementStickerControl = ({
  systemStickers,
  loadMore,
  onClose,
  onChange,
  onDelete,
}) => {
  useVirtualPageView({
    title: 'Create a card - Select a sticker',
    path: '/element/sticker',
  });

  const scrollRef = useBottomScrollListener(
    () => {
      if (systemStickers?.total > systemStickers?.records?.length) {
        loadMore();
      }
    },
    500,
    750,
    { leading: false },
  );

  return (
    <div className="card-element-sticker-control-content">
      <div className="card-element-control-header">
        <DismissButton onClick={onClose} />

        <span className="card-element-control-header-title">
          Choose a sticker
        </span>
      </div>

      <div className="card-element-control-body" ref={scrollRef}>
        <div className="card-element-sticker-control-list">
          {onDelete && (
            <button
              id="sticker-delete"
              className="btn-sticker-select sticker-delete"
              onClick={() => {
                onDelete();
                onClose();
              }}
            >
              <TrashIcon color="#ffffff" size="20px" className="mb-1" />
              <span className="text-sm">Remove</span>
            </button>
          )}

          {systemStickers &&
            systemStickers.records.map(systemSticker => {
              return (
                <button
                  id={systemSticker.id}
                  key={systemSticker.id}
                  className="btn-sticker-select"
                  onClick={() => {
                    onChange(systemSticker);
                    onClose();
                  }}
                >
                  <img src={systemSticker.asset_image.url} alt="" />
                </button>
              );
            })}
        </div>

        {!systemStickers && (
          <div className="text-center">
            <NativeActivityIndicator type="white" size="sm" />
          </div>
        )}
      </div>
    </div>
  );
};

CardElementStickerControl.propTypes = propTypes;

const withSystemStickers = graphql(getSystemStickers, {
  props: ({ data: { systemStickers, loading, fetchMore } } = {}) => ({
    systemStickers,
    loading,
    loadMore: createLoadMoreMethod({
      source: systemStickers,
      recordsPath: '',
      fetchMore,
      limit: 150,
    }),
  }),
  options: {
    notifyOnNetworkStatusChange: true,
  },
});

export const CARD_ELEMENT_STICKER_CONTROL_MODAL =
  'CARD_ELEMENT_STICKER_CONTROL_MODAL';

export default withModal(
  compose(withSystemStickers)(CardElementStickerControl),
  {
    name: CARD_ELEMENT_STICKER_CONTROL_MODAL,
    dismissible: false,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    className: 'card-element-sticker-control-modal modal-floating-panel',
  },
);
